import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import './../assets/css/app/LoadingOverlay.css';

const LoadingOverlayWithProgress = ({ isLoading, message = "Loading..." }) => {
  const [progress, setProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState('');

  useEffect(() => {
    if (!isLoading) {
      setProgress(0);
      setCurrentStep('');
      return;
    }

    
    const steps = [
      { text: 'Loading...', progress: 25 },
      { text: 'Loading...', progress: 50 },
      { text: 'Loading...', progress: 75 },
      { text: 'Loading...', progress: 100 }
    ];

    let currentStepIndex = 0;
    const interval = setInterval(() => {
      if (currentStepIndex < steps.length) {
        setCurrentStep(steps[currentStepIndex].text);
        setProgress(steps[currentStepIndex].progress);
        currentStepIndex++;
      } else {
        clearInterval(interval);
      }
    }, 800); 

    return () => clearInterval(interval);
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-spinner">
          <Spin size="large" />
        </div>
        <div className="loading-text">
          {currentStep || message}
        </div>
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="progress-text">
            {progress}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlayWithProgress;




